import { adminRequest } from "./adminApi";

/**
 * Upload de l'image d'une suggestion en multipart.
 *
 * Le wrapper HTTP redux (state/utils/fetch.js) est JSON-only : appel direct via
 * adminRequest (mêmes en-têtes d'auth). On laisse axios poser le Content-Type
 * multipart (boundary).
 *
 * @return Promise<{id:number, path:string, square:string}>
 */
export const uploadSuggestionMedia = (file) => {
  const formData = new FormData();
  formData.append("media", file);

  return adminRequest({
    method: "post",
    path: "/v2/admin/store/product/suggestion/media.json",
    data: formData,
  }).then((res) => res.data.result);
};
